var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 38,
    viewBox: "0 0 59 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CA logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.9141 0V12.1778L47.4764 29.843H31.9141V37.4045H54.1366L58.2022 29.843L31.9141 0Z",
    fill: "#FF4F02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.2882 29.843H10.7309L26.2882 12.1778V0L23.739 2.89469L0 29.843L4.07069 37.4045H26.2882V29.843Z",
    fill: "#FF4F02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaLogo);
export default __webpack_public_path__ + "static/media/CA-logo.5c5e5aa66e34f7c920b4a9aae735ba42.svg";
export { ForwardRef as ReactComponent };